import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Propelovilec",
  "description": "",
  "published": "2007-07-20T00:00:00.000Z",
  "redirect_from": ["/blog/propelovilec/swizec/169"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred nekaj noÄmi sem v temi slišal Äudne zvoke in se jih skoraj malo bal, ampak nisem obupaval, tiho sem se skrival pod posteljo in Äakal konca strašnega vdora v moje domovanje in se Äudil o vzroku strahu.`}</p>
    <p>{`Nekaj kasneje ob priÅ¾ganih luÄeh pa sem opazil zabaven prizor in se nenadoma zavedel vzroka nenavadnih zvokov ... pogumna maÄka loveÄ vrteÄo eliso mojega `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=233"
      }}>{`Odstranjevalca VroÄine`}</a>{`.`}</p>
    <p>{`Haha, youtube je potemnil video ... škoda.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      